import React from "react";

const Contact = () => {
    return (
    <section id="contact" className="py-20 bg-blue-200">
        <div className="container mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold mb-4 " style={{ fontFamily: 'Young, serif' }}>Contact Me</h2>
            <p className="text-xl font-bold  my-9 " style={{ fontFamily: 'Young, serif' }}>
                Feel free to leave me a message<p>septiakhairunnisa780@gmail.com</p>
            </p>
            <a href="mailto:septiakhairunnisa780@gmail.com" className="bg-lime-700 hover:bg-lime-500 text-white font-bold py-2 px-8 rounded-lg shadow-md transition duration-300">
                Email
            </a>
        </div>
    </section>
    )
}

export default Contact;